import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error This library is not yet typed
import { isLoading, isError } from 'reference-resolvers-lite/Status'; // @ts-expect-error This library is not yet typed

import { createStandardCachedResolver } from 'reference-resolvers-lite/utils/createStandardCachedResolver';
import { CRM_OBJECT } from 'reference-resolvers-lite/constants/ReferenceTypes'; // @ts-expect-error This library is not yet typed

import { useFetchResolver } from 'reference-resolvers-lite/ResolverHooks';
import LoadingCell from '../LoadingCell';
import { AvatarCell } from '../AvatarCell';
import { getRecordHref } from '../../utils/getRecordHref';
import EmptyState from '../EmptyState';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';

const ResolvedCrmObjectCell = ({
  objectId,
  objectTypeId
}) => {
  // This caches the resolver internally
  const resolver = createStandardCachedResolver(CRM_OBJECT, objectTypeId);
  const {
    status,
    reference
  } = useFetchResolver(resolver, objectId);

  if (!objectId) {
    return /*#__PURE__*/_jsx(EmptyState, {});
  }

  if (isLoading(status) || !reference) {
    return /*#__PURE__*/_jsx(LoadingCell, {
      "data-test-id": "resolver-loading"
    });
  }

  if (isError(status)) {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: objectId
    });
  }

  const label = reference.label || '--';

  if ([CONTACT_TYPE_ID, COMPANY_TYPE_ID].includes(objectTypeId)) {
    return /*#__PURE__*/_jsx(AvatarCell, {
      type: objectTypeId === CONTACT_TYPE_ID ? 'vid' : 'companyId',
      id: objectId,
      displayName: reference.label,
      href: getRecordHref(objectTypeId, objectId),
      children: label
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {
    children: label
  });
};

export default ResolvedCrmObjectCell;